import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputAddressConnectionRelation } from './InputAddressConnectionRelation.entity';
import { InputCategoryMarkRelation } from './InputCategoryMarkRelation.entity';
import { InputSetPersonalContactRelation } from './InputSetPersonalContactRelation.entity';

export class InputAnsprechpartnerRelation<T extends EMode = EMode.entity> {
  /** Alias: categoryMarks */
  categoryMarks?: InputCategoryMarkRelation<T>;
  /** Alias: addressConnection */
  addressConnection?: InputAddressConnectionRelation<T>;
  /** Alias: setPersonalContact */
  setPersonalContact?: InputSetPersonalContactRelation<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputAnsprechpartnerRelation> = {
  categoryMarks: {
    alias: 'categoryMarks',
  },
  addressConnection: {
    alias: 'addressConnection',
  },
  setPersonalContact: {
    alias: 'setPersonalContact',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputAnsprechpartnerRelationEntityDefinition: EntitiyDefinition<InputAnsprechpartnerRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputAnsprechpartnerRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
